import {BaseService} from '../baseService.js';

/* 
 * Handles Batch Management
 */
export class BatchTaskService extends BaseService {

	constructor() {	
		super();
	}
	
	async getTasks(paging) {
		var params = '';
		if (paging) {
			params = '?' + this.toQueryParam(paging);
		}
		var data = await this.makeGETRequest('/api/resource/batch-tasks' + params);		
		return data;		
	}

	exportTasks(paging) {
		var params = '';
		if (paging) {
			params = '?' + this.toQueryParam(paging);
		}
		this.downloadFile('/api/resource/batch-tasks/export' + params);
	}
	
	async getTask(taskId) {
		var data = await this.makeGETRequest('/api/resource/batch-tasks/' + taskId);		
		return data;		
	}	
	
	async getTaskUnits(taskId, paging) {
		var params = '';
		if (paging) {
			params = '?' + this.toQueryParam(paging);
		}
		var data = await this.makeGETRequest('/api/resource/batch-tasks/' + taskId + "/units" + params);		
		return data;		
	}	

	async getTaskErrors(taskId, paging) {
		var params = '';
		if (paging) {
			params = '?' + this.toQueryParam(paging);
		}
		var data = await this.makeGETRequest('/api/resource/batch-tasks/' + taskId + '/errors' + params);		
		return data;		
	}
	
	exportTaskErrors(taskId, paging) {	
		var params = '';
		if (paging) {
			params = '?' + this.toQueryParam(paging);
		}
		this.downloadFile('/api/resource/batch-tasks/' + taskId + '/errors/export' + params);		
	}	
	
	async getBatchTaskWork(taskId, paging) {
		var params = '';
		if (paging) {
			params = '?' + this.toQueryParam(paging);
		}
		var data = await this.makeGETRequest('/api/resource/batch-tasks/' + taskId + '/batch-work-items' + params);		
		return data;		
	}
	
	async getBatchWork(taskId, workQueueId) {
		var data = await this.makeGETRequest('/api/resource/batch-tasks/' + taskId + '/batch-work-items/' + workQueueId);		
		return data;		
	}	
	
	async getBatchTaskWorkUnits(taskId, workQueueId, paging) {
		var params = '';
		if (paging) {
			params = '?' + this.toQueryParam(paging);
		}
		var data = await this.makeGETRequest('/api/resource/batch-tasks/' + taskId + "/batch-work-items/" + workQueueId + "/units" + params);		
		return data;		
	}
	
	async getAllBatchWork(paging) {
		var params = '';
		if (paging) {
			params = '?' + this.toQueryParam(paging);
		}
		var data = await this.makeGETRequest('/api/resource/batch-work-items' + params);		
		return data;		
	}	
	
	async getBatchWorkUnits(workQueueId, paging) {
		var params = '';
		if (paging) {
			params = '?' + this.toQueryParam(paging);
		}
		var data = await this.makeGETRequest('/api/resource/batch-work-items/' + workQueueId + '/units' + params);
		return data;
	}

	exportBatchWorkUnits(workQueueId, paging) {
		var params = '';
		if (paging) {
			params = '?' + this.toQueryParam(paging);
		}
		this.downloadFile('/api/resource/batch-work-items/' + workQueueId + '/units/export' + params);
	}
	
	async getBatchNodes() {
		var data = await this.makeGETRequest('/api/resource/batch-work-items/nodes');		
		return data;		
	}	
	
	async submitTask(batchSubmitModel) {
		var saved = await this.makePOSTRequest('/api/resource/batch-tasks', batchSubmitModel);
		return saved;		
	}
	
	async deleteBatchTask(taskIds) {
		var data = await this.makeDELETERequest('/api/resource/batch-tasks', taskIds);		
		return data;		
	}

	async clearCompleteTasks() {
		var data = await this.makeDELETERequest('/api/resource/batch-tasks/clear-complete');
		return data;
	}
	
	async cancel(taskId) {
		var saved = await this.makePUTRequest('/api/resource/batch-tasks/' + taskId + '/cancel');
		return saved;		
	}
	
	async suspend(taskId) {
		var saved = await this.makePUTRequest('/api/resource/batch-tasks/' + taskId + '/suspend');
		return saved;		
	}	
	
	async resume(taskId) {
		var saved = await this.makePUTRequest('/api/resource/batch-tasks/' + taskId + '/resume');
		return saved;		
	}	
	
	async restart(taskId, calcStage) {
		var params = '';
		if (calcStage) {
			params = '?calcStage=' + calcStage;
		}
		
		var saved = await this.makePUTRequest('/api/resource/batch-tasks/' + taskId + '/restart' + params);
		return saved;		
	}

	async locateRunningThreads(taskId) {
		var data = await this.makeGETRequest('/api/resource/batch-tasks/' + taskId + '/running-threads');
		return data;
	}
	
}


